import { isoToDateTimeString } from "utils/date";

export default [
  { field: 'changeAt', headerAlign: 'center', headerName: 'Дата замены', width: 120,
    valueGetter: (value) => isoToDateTimeString(value)},
  { field: 'name', headerAlign: 'center', headerName: 'Касса', width: 160,
    valueGetter: (value, row) => `${row.model} - ЗН ${row.factoryNumber}`},
  { field: 'connectedAt', headerAlign: 'center', headerName: 'Подключена', width: 120,
    valueGetter: (value) => isoToDateTimeString(value)},  
  { field: 'lastConnectedAt', headerAlign: 'center', headerName: 'Связь', width: 120,
    valueGetter: (value) => isoToDateTimeString(value)},  
  { field: 'info', flex: 2, headerAlign: 'center', headerName: 'Замена', align: 'right'  }
];